import { TailSpin } from "react-loader-spinner";

function LoadingIndicator() {
  return (
    <div className="flex items-center gap-2">
      <TailSpin
        height="28"
        width="28"
        color="gray"
        ariaLabel="tail-spin-loading"
      />
      <span className="text-gray-600">Loading...</span>
    </div>
  );
}

export default LoadingIndicator;
